interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const buildPages = (): (number | string)[] => {
    const result: (number | string)[] = [];
    const start = Math.max(2, page - 1);
    const end = Math.min(totalPages - 1, page + 1);
    result.push(1);
    if (start > 2) result.push("left-ellipsis");
    for (let i = start; i <= end; i += 1) result.push(i);
    if (end < totalPages - 1) result.push("right-ellipsis");
    result.push(totalPages);
    return result;
  };

  return (
    <nav aria-label="分页导航" className="mt-10 flex items-center justify-center gap-2 flex-wrap">
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page === 1}
        className={`h-9 px-3 inline-flex items-center gap-1 rounded-md border text-xs transition-colors whitespace-nowrap ${
          page === 1
            ? "border-background-200/60 text-foreground-800 cursor-not-allowed"
            : "border-background-300 text-foreground-300 hover:border-accent-500 hover:text-accent-500 cursor-pointer"
        }`}
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {buildPages().map((item) =>
        typeof item === "number" ? (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            aria-current={item === page ? "page" : undefined}
            className={`w-9 h-9 rounded-md text-xs font-label transition-colors cursor-pointer ${
              item === page
                ? "bg-primary-500 text-foreground-50"
                : "border border-background-300 text-foreground-300 hover:border-accent-500 hover:text-accent-500"
            }`}
          >
            {item}
          </button>
        ) : (
          <span key={item} className="w-6 text-center text-foreground-700 text-xs">
            ···
          </span>
        ),
      )}

      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page === totalPages}
        className={`h-9 px-3 inline-flex items-center gap-1 rounded-md border text-xs transition-colors whitespace-nowrap ${
          page === totalPages
            ? "border-background-200/60 text-foreground-800 cursor-not-allowed"
            : "border-background-300 text-foreground-300 hover:border-accent-500 hover:text-accent-500 cursor-pointer"
        }`}
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}